import axios from "axios";
import instance from "../../../../axios";
import { instanceTokenLess } from "../../../../axios";

export const STAFFUSER_URL = `${process.env.REACT_APP_API_URL}/adminuser`;
export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/dashboards`;
export const LOCAL_URL = `http://localhost:9171/leagueopsv2api/api`;
export const GAMERJI_V2_URL = `${process.env.REACT_APP_GAMERJI_API_URL}`;
export const REACT_APP_CELLCARD_API_URL = `${process.env.REACT_APP_CELLCARD_API_URL}`;
// CREATE =>  POST: add a new StaffUser to the server
export function createStaffUser(staffUser) {

  // return axios.post(`${STAFFUSER_URL}/add`, staffUser);
  return instance.post(`${STAFFUSER_URL}/add`, staffUser)
    .then(res => {
      return res;
    })
}

// READ
// export function getAllStaffUsers(queryParams) {
//   console.log('queryParams ssssssssssss:', queryParams.selectedCompanyBaseUrl)
//   // return instance.post(`${queryParams?.selectedCompanyBaseUrl}/transaction/list`, queryParams)
//   return instance.post(`${queryParams?.selectedCompanyBaseUrl}user/list`, queryParams)
//     .then(res => {
//       return res;
//     })
// }

// READ
export function getAllStaffUsers(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${STAFFUSER_URL}/list`, queryParams)
    .then(res => {
      return res;
    })
}

export function getAllStaffUsersExport(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${STAFFUSER_URL}/list-export`, queryParams)
    .then(res => {
      return res;
    })
}

export function getAllAppUsers(queryParams) {
  console.log("`${queryParams?.selectedCompanyBaseUrl}user/list`",`${queryParams?.selectedCompanyBaseUrl}user/list`)
  // return instance.post(`${queryParams?.selectedCompanyBaseUrl}/transaction/list`, queryParams)
  return instanceTokenLess.post(`${queryParams?.selectedCompanyBaseUrl}user/list`, queryParams)
  // return instanceTokenLess.post(`http://localhost:9171/api/user/list`, queryParams)
    .then(res => {
      return res;
    })
}

export function createUserIdfun(queryParams) {
 // console.log("createUserId->crateUserIdfun()")
  //console.log(`${queryParams?.selectedCompanyBaseUrl}/user/createUserId`,queryParams)
  // return instance.post(`${queryParams?.selectedCompanyBaseUrl}/transaction/list`, queryParams)
  return instanceTokenLess.post(`${GAMERJI_V2_URL}/user/createUserId`, queryParams)
  // return instanceTokenLess.post(`http://localhost:9171/api/user/createUserId`, queryParams)
    .then(res => {
     // console.log("createUserID API fun staffUserCurd",res)
      return res;
    })
}

export function createSignUpfun(queryParams) {
 // console.log("createUserId->createSignUpfun()")
 // console.log(`${queryParams?.selectedCompanyBaseUrl}/user/createSignup`,queryParams)
   // return instance.post(`${queryParams?.selectedCompanyBaseUrl}/transaction/list`, queryParams)
   return instanceTokenLess.post(`${GAMERJI_V2_URL}/user/createSignup`, queryParams)
   // return instanceTokenLess.post(`http://localhost:9171/api/user/createUserId`, queryParams)
     .then(res => {
      // console.log("createUserID API fun staffUserCurd",res)
       return res;
     })
 }

export function getDeleteRequest(queryParams) {
  return instance.post(`${process.env.REACT_APP_API_URL}/deletedUser/list`, queryParams)
    .then(res => {
      return res;
  })
}

export function inActiveDeleteRequest(queryParams) {
  return instance.put(`${process.env.REACT_APP_API_URL}/deletedUser/inactive`, queryParams)
    .then(res => {
      return res;
  })
}
export function fetchModulePermissions(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${process.env.REACT_APP_API_URL}/module/permission-list`, queryParams)
    .then(res => {
      return res;
    })
}
export function updateAppUser(appUser) {
  console.log('appUser $$$$:', appUser)
  //return instanceTokenLess.post(`${appUser?.selectedCompanyBaseUrl}user/updateUser/${appUser.user_id}`, appUser)
  return instanceTokenLess.post(`${appUser?.selectedCompanyBaseUrl}user/updateUser/${appUser.user_id}`, appUser)
    .then(res => {
      return res;
    })
  // return axios.post(`${STAFFUSER_URL}/update/${staffUser._id}`, staffUser);
}
export function updateRole(role) {    /// isko udana h
  return instance.post(`${process.env.REACT_APP_API_URL}/role/update/${role.userId}`, role)
    .then(res => {
      return res;
    })
  // return axios.post(`${STAFFUSER_URL}/update/${staffUser._id}`, staffUser);
}
export const getPermissionList = (data) => {
  console.log("getPermissionList>>>>>>>>>payload",data)
  return instance.post(`${process.env.REACT_APP_API_URL}/role/permission-list`,data
      )
      .then(res => {
          return res;
          console.log(res)
      }).catch(err=>{
         return  ({
          "success": false,
      });
      })
}
export function fetchPermissions(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.get(`${process.env.REACT_APP_API_URL}/permission/list`, queryParams)
    .then(res => {
      return res;
    })
}

export function fetchRolePermissions(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${process.env.REACT_APP_API_URL}/role/permission-list`, queryParams)
    .then(res => {
      return res;
    })
}

export function fetchCompanyList(queryParams) {
  return instance.post(`${process.env.REACT_APP_API_URL}/company/dropdown/list`, queryParams)
    .then(res => {
      return res;
    })
};

export function fetchCompanyDropdownList(queryParams) {
  return instance.post(`${process.env.REACT_APP_API_URL}/v3/dropdown/company/medium`, queryParams)
    .then(res => {
      return res;
    })
};

export function fetchCompanyDropdownLastActiveDate(queryParams) {
  return instance
    .post(
      `${process.env.REACT_APP_API_URL}/v3/dropdown/company/allDetails`,
      queryParams
    )
    .then((res) => {
      return res;
    });
};
export function fetchRoleDropdownList(queryParams) {
  return instance.post(`${process.env.REACT_APP_API_URL}/role/list`, queryParams)
    .then(res => {
      return res;
    })
};


export function fetchCountryList(queryParams) {
  if (queryParams)
  {
    return instance.post(`${process.env.REACT_APP_API_URL}/country/dropdown/list/${queryParams}`, queryParams)
    .then(res => {
      return res;
    })
  }
  return instance.post(`${process.env.REACT_APP_API_URL}/country/dropdown/list`, queryParams)
    .then(res => {
      return res;
    })
};

export function fetchCountriesDropdownList(queryParams) {
  if(queryParams?.code){
    return instance
    .post(`${process.env.REACT_APP_API_URL}/country/Dropdown/list/${queryParams?.code}`)
    .then((res) => {
      return res;
    });
  }else{
    return instance
    .post(`${process.env.REACT_APP_API_URL}/country/Dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
  }
}


export function fetchCountryListDropdownList(queryParams) {
  return instance.post(`${process.env.REACT_APP_API_URL}/country/dropdown/list`, queryParams)
    .then(res => {
      return res;
    })
};

export function getMainDashboardUser(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${DASHBOARD_URL}/dashboard-users`, queryParams)
    .then(res => {
      return res;
    })
}

export function getMainDashboardWallet(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${DASHBOARD_URL}/dashboard-wallet-coins`, queryParams)
    .then(res => {
      return res;
    })
}

export function getMainDashboardWalletRmg(queryParams) {
  // return axios.post(`${STAFFUSER_URL}/list`, queryParams);
  return instance.post(`${DASHBOARD_URL}/dashboard-wallet-rmg`, queryParams)
    .then(res => {
      return res;
    })
}

// READ
export function getUserLogs(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/users/log-list`, queryParams);
}
// READ
export function getUserQueries(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/tickets/list`, queryParams);
}
// READ
export function getUserContacts(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/users/contacts-list`, queryParams);
}
export function getUserContests(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/contests/app-user-list`, queryParams);
}
// READ
export function getUserRecentContests(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/contests/recent-list`, queryParams);
}
// READ
export function getUserUpcomingContests(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/contests/upcoming-list`, queryParams);
}
// READ
export function getUserTournamnets(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/events/user-list`, queryParams);
}
export function getUserTransactions(queryParams) {
  return axios.post(`${process.env.REACT_APP_API_URL}/transactions/list`, queryParams);
}

export function getStaffUserById(staffUserId) {
  return instance.get(`${STAFFUSER_URL}/get/${staffUserId}`)
    .then(res => {
      return res;
    })
  // return axios.post(`${STAFFUSER_URL}/get/${staffUserId}`);
}

export function getStaffUserCompany(staffUserCompany) {
  return instance.get(`${process.env.REACT_APP_API_URL}/company/get/${staffUserCompany}`)
    .then(res => {
      return res;
    })
  // return axios.post(`${STAFFUSER_URL}/get/${staffUserId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findStaffUsers(queryParams) {
  return axios.post(`${STAFFUSER_URL}/find`, { queryParams });
}

// UPDATE => PUT: update the StaffUser on the server
export function updateStaffUser(staffUser) {
  return instance.post(`${STAFFUSER_URL}/update/${staffUser._id}`, staffUser)
    .then(res => {
      return res;
    })
  // return axios.post(`${STAFFUSER_URL}/update/${staffUser._id}`, staffUser);
}

// UPDATE Status
export function updateStatusForStaffUsers(ids, status) {
  return axios.post(`${STAFFUSER_URL}/updateStatusForStaffUsers`, {
    ids,
    status
  });
}

// DELETE => delete the StaffUser from the server
export function deleteStaffUser(staffUserId) {

  return instance.post(`${STAFFUSER_URL}/delete/${staffUserId}`)
    .then(res => {
      return res;
    })

  // return axios.post(`${STAFFUSER_URL}/delete/${staffUserId}`);
}

// DELETE StaffUsers by ids
export function deleteStaffUsers(ids) {
  return axios.post(`${STAFFUSER_URL}/deleteStaffUsers`, { ids });
}
